<template>
    <view>
        <div class="content_page">
        <HeaderPage/>
    <div class="container">
        <div class="row">
            <div class="col-md-12 news_page_box">
                <div class="path" v-if="pageerror==0">
                    <i class="fa fa-television"></i>当前位置： <span v-if="newsColumn.name">{{newsColumn.name}}&nbsp;>&nbsp;</span>{{ subColumnName }}
                </div>
                <div class="path" v-if="pageerror==1">
                    <i class="fa fa-television"></i>当前位置： 系统错误提示
                </div>
                <div class="content" v-if="pageerror==0">
                    <h2 class="wow fadeInDown">{{basic.title}}</h2>
                    <div class="type wow fadeInDown">
                        发布日期：{{formatTimestamp(basic.ctime)}} <span style="padding-left:25px;" v-if="basic.infofrom">来源：{{basic.infofrom}}</span><span style="padding-left:25px;" v-if="basic.editor">编辑：{{basic.editor}}</span>
                    </div>
                    <div class="text wow fadeInLeft">
                        <div id="dplayer" style="width: 100%; height: 100%"></div>  
                    </div>
                </div>
                <div id="loading-mask" v-if="isLodding == 1">
                    <div class="loading-wrapper">
                        <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
                    </div>
                </div>
                <div style="text-align:center; position: absolute; top:25%; width: 100%;" v-if="pageerror==1">
                    <div><img src="../../assets/images/nodatamsg.png"  style="width:350px; height:auto;"></div>
                    <div style="color:#999999; margin-top:10px;">内容不存在或预览过期~</div>
                </div>

            </div>
            <!--div class="col-md-4 news_page_right">
                <RightPage/>
            </div-->
        </div>
    </div>
    </div>
</view>
</template>
<script>
    import HeaderPage from '@/components/HeaderUnit.vue'
    //import RightPage from '@/components/RightUnit.vue'
    import { post } from '@/request'
    import DPlayer from 'dplayer'
    import logoPath from '@/assets/images/site_logo.png';
    export default {
        components: {
            HeaderPage,
            //RightPage
        },
        name: 'in-video',
        props: {
            source: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                pageerror: 0,
                previewKey: '',
                isLodding: 1,
                newsId:null,
                basic: {},
                newsColumn: [],
                title: '巧家新闻网—巧家县第一新闻门户网站',
                keywords: ['巧家新闻','巧家','白鹤滩','巧家县','巧家新闻网'],
                description: '巧家县第一新闻门户网站，巧家新闻网由中共巧家县委宣传部主办、巧家县人民政府新闻中心承办，是对外宣传推介巧家、展示巧家形象、外界了解巧家的重要网络平台。',
                videoUrl: null, // 用于存储视频地址  
                videoImg: null,
                dp: null, // 用于存储DPlayer实例             
            }
        },
        created() {
            this.previewKey = this.$route.query.previewKey
           // watch 路由的参数，以便再次获取数据
            this.$watch(
            () => this.$route.params,
            () => {
                this.newsId = this.$route.params.id.replace(/\.html$/, '')
                //console.log(this.newsId)
                this.getVideoInfo()
            },
            // 组件创建完后获取数据，
            // 此时 data 已经被 observed 了
            { immediate: true }
            )
        },
        computed: {  
            subColumnName() {  
                return this.newsColumn && this.newsColumn['0'] ? this.newsColumn['0'].name : null;  
            }
        },  
        mounted() {
            this.setTitle();  
            this.setKeywords();  
            this.setDescription();  
        },
        methods: {
            formatTimestamp(timestamp) {  
                return this.$formatTimeAgo(timestamp); // 调用全局方法  
            }, 
            setTitle() {  
                document.title = this.title; // 设置标题  
            },  
            setKeywords() {  
                const metaKeywords = document.createElement('meta');  
                metaKeywords.name = 'keywords';  
                metaKeywords.content = this.keywords.join(','); // 设置关键词  
                document.head.appendChild(metaKeywords);  
            },  
            setDescription() {  
                const metaDescription = document.createElement('meta');  
                metaDescription.name = 'description';  
                metaDescription.content = this.description; // 设置描述  
                document.head.appendChild(metaDescription);  
            }, 
            async getVideoInfo() {  
                let that = this
                let url = this.newsId
                that.isLodding = 1
                try {  
                    const postData = {};  
                    if(that.previewKey){
                        url = that.newsId+'?previewKey='+this.previewKey
                    }
                    const response = await post('video/'+url, postData);  
                    //console.log(response)
                    that.isLodding = 0
                    this.pageerror = 0 
                    document.title = response.basic.title
                    that.newsColumn = response.column
                    this.basic = response.basic
                    this.videoUrl = 'https://images.ztnews.net'+response.video.video;  
                    this.videoImg = response.basic.cover;  
                    this.initializePlayer(); // 获取到地址后初始化播放器
                } catch (error) {  
                    this.pageerror = 1 
                    that.isLodding = 0
                }  
            }, 
            initializePlayer() {  
                if (this.videoUrl) {  
                    this.dp = new DPlayer({  
                    container: document.getElementById('dplayer'),  
                    video: {  
                        url: this.videoUrl, // 使用从接口获取的视频地址  
                        pic: this.videoImg, // 默认封面图片路径，您可以根据需要替换  
                        type: 'auto',
                    },
                    fullscreen: {  
                        enabled: true, // 确保全屏功能已启用  
                        // 其他全屏配置...  
                    },  
                    contextmenu: [
                        {
                            text: '技术支持：昭通新闻网',
                            link: 'https://www.ztnews.net',
                        },
                        {
                            text: '开发者：李才配',
                            link: '',
                        },
                    ],
                    highlight: [ // 进度条时间点高亮
                        {
                        text: '10M',
                        time: 600
                        },
                        {
                        text: '20M',
                        time: 1200
                        }
                    ],
                    logo: logoPath,
                    theme: '#FADFA3',
                    loop: true,
                    lang: 'zh-cn',
                    screenshot: true,
                    hotkey: true,
                    preload: 'auto',
                    autoplay: true, // 是否自动播放  
                    mute: true, //默认静音增加视频自动播放成功率
                    // ...其他配置项  
                    });  
                } else {  
                    console.error('视频地址未获取到，无法初始化播放器');  
                }  
            },
            toggleFullscreen() {  
                if (!document.fullscreenElement) {  
                    this.$refs.videoElement.requestFullscreen()  
                    .catch(err => {  
                        console.error('Error attempting to enable full-screen mode:', err);  
                    });  
                } else {  
                    if (document.exitFullscreen) {  
                    document.exitFullscreen();  
                    }  
                }  
            },     
        },
    }
</script>
<style scoped>  
.content_page{ width: 100%; background: #ffffff;}

.player-container {  
  width: 100%; /* 设置容器宽度 */  
  height: 0; /* 高度由视频内容决定 */  
  padding-bottom: 56.25%; /* 16:9 的视频比例 */  
  position: relative;  
  overflow: hidden;  
}  
  
.player-container video {  
  position: absolute;  
  top: 0;  
  left: 0;  
  width: 100%;  
  height: 100%;  
}  
</style> 